'use client';

import React, { memo, useMemo, useState } from 'react';
import type { ClarificationSubmissionMeta } from '@/lib/chat/clarify';

export const ClarificationAckNotice = memo(({ ack }: { ack: ClarificationSubmissionMeta }) => {
  const [open, setOpen] = useState(false);
  const topics = useMemo(() => {
    return (ack.questions || [])
      .slice(0, 3)
      .map((question) => question.replace(/[?.!]+$/, '').trim())
      .filter(Boolean);
  }, [ack.questions]);
  const summary =
    topics.length > 0
      ? topics.join(', ')
      : ack.agentLabel
        ? `${ack.agentLabel}'s notes`
        : 'those details';
  return (
    <div className="mb-3 rounded-2xl border border-success/40 bg-success/10 p-3 text-foreground">
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span>Got it — I&apos;ll use your clarifications on {summary}.</span>
        <button
          type="button"
          className="text-xs underline-offset-4 hover:underline"
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? 'Hide details' : 'View details'}
        </button>
      </div>
      {open && (
        <div className="mt-3 space-y-2 text-xs text-foreground">
          {ack.questions.map((question, idx) => (
            <div key={`${ack.requestId}-ack-${idx}`} className="rounded-lg border border-success/30 p-2">
              <p className="font-medium">{question}</p>
              <p className="mt-1 whitespace-pre-wrap">
                {ack.answers[idx] && ack.answers[idx] !== '[placeholder]' ? ack.answers[idx] : 'Placeholder accepted'}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
ClarificationAckNotice.displayName = 'ClarificationAckNotice';

export default ClarificationAckNotice;
